const NoUserContent = () => {
  return (
    <div className="card-flat flex-col items-center gap-4 p-16">
      <p>This organizer hasn’t created any campaigns yet!</p>
    </div>
  );
};

export default NoUserContent;
